/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5c67b249&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5c67b249&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c67b249"]])

export default __exports__